import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full bg-black py-6 px-4 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="flex items-center mb-4 md:mb-0">
          <img 
            src="/assets/logo-streetvape-nubes.png" 
            alt="Street Vape Clouds Logo" 
            className="h-10 w-auto mr-3"
          />
          <span className="text-gray-300">© {currentYear} Street Vape</span>
        </div>
        <div className="text-gray-400 text-sm">
          Próximamente en España
        </div>
      </div>
    </footer>
  );
}

export default Footer;